import { adaptProjectGroupedStatements } from '@components/StatementRowsCommon/adapters';
import { groupDisplayedStatementTotalsByCurrency } from '@components/StatementRowsCommon/helpers';

export const getProjectGroupedStatementRows = (contacts = []) => {
    if (!Array.isArray(contacts) || contacts.length === 0) {
        return [];
    }

    const statementRows = [];

    for (const contact of contacts) {
        for (const billingInfo of contact?.BillingInfos || []) {
            statementRows.push(...adaptProjectGroupedStatements(billingInfo?.Transactions || []));
        }
    }

    return statementRows;
};

export const groupProjectGroupedStatementsTotalsByCurrency = (contacts, defaultCurrency) => {
    const statementRows = getProjectGroupedStatementRows(contacts);
    return groupDisplayedStatementTotalsByCurrency(statementRows, defaultCurrency);
};
